// Normalise instrument labels for display. Instrument values are stored
// inconsistently ("guitar" vs "Guitar" vs "ELECTRIC GUITAR"), which makes cards
// and profiles look mismatched. This title-cases each word for a consistent
// presentation without mutating the stored data.
export const formatInstrument = (instrument) => {
  if (typeof instrument !== "string") return "";
  const trimmed = instrument.trim();
  if (!trimmed) return "";
  return trimmed
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
